import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as Constants from "../../shared/Constants";
import * as actions from '../../store/actions/index';
import PortalForm from '../PortalForm/PortalForm';
import {clearForm} from "../../shared/utility";
import Spinner from '../../UI/Spinner/Spinner';

export class AddAccount extends Component {

    componentDidMount() {
        this.props.setDisplayMessage(null);
        if(!this.props.portalsList || !this.props.portalsList.length > 0) {
            this.props.fetchPortals();
        }
        window.scrollTo(0, 0);
    }

    addAccountHandler = (formData) => {
        // console.log("[AddAccount] addAccountHandler - formData - ", formData );
        //console.log("Portal data selected portal: ", this.props.selectedPortal);
        if(formData){
            formData.targetPortal = this.props.selectedPortal.parentPortalId && this.props.selectedPortal.portalBrandName ? this.props.selectedPortal.portalBrandName : formData.targetPortal; 
            if(this.props.selectedPortal.portalShortName === 'CAP'){
                this.props.addBankAccount(formData);
            } else if(this.props.selectedPortal.portalShortName === 'BSCA' || this.props.selectedPortal.portalShortName === 'HARVARDPILGRIM' || this.props.selectedPortal.portalShortName === 'MORGANWHITE'){
                formData.portalIndicator = this.props.selectedPortal.portalShortName;
                this.props.addMyuhcSubPrtlAccount(formData);
            } else{
                this.props.addAccount(formData);
            }
        }
    }

    clearFormData = (portalForm, ignoreFields) =>{
        // console.log("[AddAccount] clearFormData", targetPortal);
        this.props.setDisplayMessage(null);
        return clearForm(portalForm, ignoreFields);
    }

    setAddAccountData = (form) => {
        if(this.props.user.userType !== Constants.SESSION_SUPERUSER) {
            delete form["UUID"];
        }
        return form;
    }

    render() {

        let form = <Spinner/>;
        if(!this.props.portalsLoading) {
            form = (
                <PortalForm
                    formHeader = {Constants.ADD_ACCOUNT}
                    formMessage = {Constants.ADD_ACCOUNT_ALL_FIELDS_REQUIRED}
                    message = {this.props.message}
                    selectedPortal = {this.props.selectedPortal}
                    portalsList = {this.props.portalsList}
                    portalsInfo = {this.props.portalsInfo}
                    portalInfoLoading = {this.props.portalsLoading}
                    submitButtonLabel = {Constants.ADD_ACCOUNT}

                    submitFormHandler = {this.addAccountHandler}
                    resetFormHandler = {this.clearFormData}
                    portalSelectHandler = {this.props.setAddAccountPortal}
                    displayMessageHandler = {this.props.setDisplayMessage}
                    addFunctionSpecificData = {this.setAddAccountData}
                />
            );
        }

        // console.log("[AddAccount] render", this.props);
        return form;
    }
}

export const mapStateToProps = state => {
    return {
        selectedPortal: state.addAccount.addAccountPortal,
        message: state.addAccount.message,
        portalsList: state.addAccount.portals,
        portalsInfo: state.addAccount.portalsInfo,
        portalsLoading: state.addAccount.portalsLoading,
        portalInfoLoading: state.addAccount.portalInfoLoading,
        user: state.usr.user,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        addBankAccount: (memberInfo) => dispatch(actions.addBankAccount(memberInfo)),
        addMyuhcSubPrtlAccount: (memberInfo) => dispatch(actions.addMyuhcSubPrtlAccount(memberInfo)),
        addAccount: (memberInfo) => dispatch(actions.addAccount(memberInfo)),
        setDisplayMessage: (message) => dispatch(actions.setDisplayMessage(message)),
        setAddAccountPortal: (portalInfo) => dispatch(actions.setAddAccountPortal(portalInfo)),
        fetchPortals: () => dispatch(actions.fetchAccountPortals())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAccount);
